<template>
    <div class="flex items-center justify-between px-4 py-3 sm:px-6">
        <div class="flex flex-1 items-center justify-between">
            <!-- <div class="mr-5">
                <p class="text-sm text-gray-700">
                    Showing
                    <span class="font-medium">{{ startIndex + 1 }}</span>
                    to
                    <span class="font-medium">{{ Math.min(endIndex, totalItems) }}</span>
                    of
                    <span class="font-medium ">{{ totalItems }}</span>
                    results
                </p>
            </div> -->
            <div class="flex gap-2">
                <button @click="onPreviousPage" :disabled="currentPage === 1"
                    class="relative inline-flex items-center rounded-md px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 bg-white text-black hover:bg-gray-50"
                    :class="currentPage === 1 ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'">
                    Previous
                </button>

                <div class="flex gap-1">
                    <template v-for="page in displayedPages" :key="page">
                        <span v-if="page === '...'"
                            class="relative inline-flex items-center px-3 py-2 text-sm font-semibold text-gray-700">...</span>
                        <button v-else @click="onPageChange(page)"
                            class="relative inline-flex items-center px-3 py-2 text-sm font-semibold ring-1 ring-inset rounded-lg"
                            :class="currentPage === page
                                    ? 'bg-[#012351] text-white ring-[#012351] rounded-lg'
                                    : 'ring-gray-300 hover:bg-gray-50 rounded-lg'
                                ">
                            {{ page }}
                        </button>
                    </template>
                </div>

                <button @click="onNextPage" :disabled="currentPage === totalPages"
                    class="relative inline-flex items-center rounded-md px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 bg-white text-black hover:bg-gray-50"
                    :class="currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'">
                    Next
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    currentPage: { type: Number, required: true },
    pageSize: { type: Number, required: true },
    totalItems: { type: Number, required: true },
});

const emit = defineEmits(['update:currentPage']);

const totalPages = computed(() => Math.max(1, Math.ceil(props.totalItems / props.pageSize)));
const startIndex = computed(() => (props.currentPage - 1) * props.pageSize);
const endIndex = computed(() => Math.min(startIndex.value + props.pageSize, props.totalItems));

const displayedPages = computed(() => {
    const maxDisplayed = 5;
    const pages = [];
    let start = Math.max(1, props.currentPage - Math.floor(maxDisplayed / 2));
    let end = Math.min(totalPages.value, start + maxDisplayed - 1);

    if (end === totalPages.value) {
        start = Math.max(1, end - maxDisplayed + 1);
    }

    if (start > 1) {
        pages.push(1);
        if (start > 2) pages.push('...');
    }

    for (let i = start; i <= end; i++) {
        pages.push(i);
    }

    if (end < totalPages.value) {
        if (end < totalPages.value - 1) pages.push('...');
        pages.push(totalPages.value);
    }

    return pages;
});

const onPreviousPage = () => {
    if (props.currentPage > 1) {
        emit('update:currentPage', props.currentPage - 1);
    }
};

const onNextPage = () => {
    if (props.currentPage < totalPages.value) {
        emit('update:currentPage', props.currentPage + 1);
    }
};

const onPageChange = (page) => {
    emit('update:currentPage', page);
};
</script>